import ICategoriesDescription from 'types/minimum-wage/ICategoriesDescription';

export const createEmptyCategoriesDescription = (): ICategoriesDescription => {
  return {
    id: 0,
    category1: null,
    category2: null,
    category3: null,
    category4: null,
    category5: null,
    category6: null,
    category7: null,
    category8: null,
    category9: null,
    category10: null,
    category11: null,
    category12: null,
    category13: null,
    category14: null,
    category15: null,
  };
};
